// extracted by mini-css-extract-plugin
export var h2 = "partners-module--h2--zaoVk";
export var offsetWrapper = "partners-module--offsetWrapper--8a71A";
export var pageContainer = "partners-module--pageContainer--M9j+r";
export var partners = "partners-module--partners--WUm3E";
export var sectionPartners = "partners-module--sectionPartners--US2Jj";